'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    render: function render(h) {
        return h('input', {
            ref: 'valueInput',
            props: {
                value: this.value
            }
        });
    },

    model: {
        event: 'changemodel'
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-dateinputs-vue-wrapper/node_modules/@progress/kendo-base-components-vue-wrapper/dist/es/kendo-base-input-component/index.js
// module id = 712
// module chunks = 0